export const setUnvisitedPlacesNearbyFailed = ({ reason }) => state => {
  return {
    ...state,
    unvisitedPlacesNearby: {
      ...state.unvisitedPlacesNearby,
      lastFetch: {
        failed: true,
        lastFailure: Date.now(),
        reason: reason.reason || reason,
      },
      loadingUnvisitedPlacesNearby: false,
    },
  };
};
